import BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';

export function isCollapsedHublistOrRightPane(browserWidth: BrowserWidthBucket) {
    /*the threshold is set set at this point for so that either
     hublist or rightpane is shown when the size of the screen is that of a tablet
     */
    if (browserWidth <= BrowserWidthBucket.From1000_To1079) {
        return true;
    }
    return false;
}
